export default __webpack_public_path__ + "static/media/tunnel_collect.66825fdc.jpg";